import { NAV_LINKS } from "@/data/content";

export const Footer = () => {
  const go = (href) =>
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });

  return (
    <footer
      data-testid="footer"
      className="bg-background border-t border-border py-14 sm:py-20"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-10">
          <div>
            <p className="font-display text-4xl sm:text-5xl text-foreground tracking-tight">
              Form Pathway<span className="text-accent">.</span>
            </p>
            <p className="mt-4 max-w-xs text-sm text-muted-foreground leading-relaxed">
              Cinematic listing films, composed from the photography you already
              own.
            </p>
          </div>
          <div className="flex flex-wrap gap-x-8 gap-y-3">
            {NAV_LINKS.map((l) => (
              <button
                key={l.href}
                data-testid={`footer-nav-${l.label.toLowerCase()}`}
                onClick={() => go(l.href)}
                className="text-xs tracking-[0.18em] uppercase text-foreground/60 hover:text-accent transition-colors"
              >
                {l.label}
              </button>
            ))}
          </div>
        </div>
        <div className="mt-14 pt-7 border-t border-border flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <p className="text-xs text-muted-foreground tracking-wide">
            © {new Date().getFullYear()} Form Pathway Studio. All rights reserved.
          </p>
          <p className="text-xs text-muted-foreground tracking-wide">
            Editorial property films · London · Worldwide
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
